import config from 'config'
import ProductLinks from 'theme/components/core/ProductLinks.vue'
import ProductCustomOptions from 'theme/components/core/ProductCustomOptions.vue'
import ProductBundleOptions from 'theme/components/core/ProductBundleOptions.vue'
import Spinner from 'theme/components/core/Spinner.vue'
import AddToWishlist from 'theme/components/core/blocks/Wishlist/AddToWishlist-v2.vue'
import InstantCheckout from 'src/modules/vsf-instant-checkout/components/InstantCheckout.vue'
import AddToCart from 'theme/components/core/AddToCart.vue'
import NoSSR from 'vue-no-ssr'
import { mapGetters } from 'vuex'
import { localizedRoute, currentStoreView } from '@vue-storefront/core/lib/multistore'

export const ProductMixin = {
  name: 'ProductMixin',
  components: {
    ProductLinks,
    ProductCustomOptions,
    ProductBundleOptions,
    Spinner,
    AddToWishlist,
    InstantCheckout,
    AddToCart,
    'no-ssr': NoSSR
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct',
      attributesByCode: 'attribute/attributeListByCode',
      getAvaliableQuantity: 'calendar/getAvaliableQuantity',
      getMenuCategories: 'category-next/getMenuCategories',
      isAddingToCart: 'cart/getIsAdding',
      isVirtualInCart: 'cart/isVirtualInCart',
      isCartFullOfTryOn: 'cart/isCartFullOfTryOn',
      isInstantCheckoutRegistered: 'instant-checkout/getSupported'
    }),
    isAddToCartDisabled () {
      return this.isStockInfoLoading ||
        (this.isOnline && !this.maxQuantity && this.isSimple) ||
        ((this.getCurrentProduct.type_id === 'sirent' || this.getCurrentProduct.type_id === 'configurable') && (!this.getAvaliableQuantity)) ||
        (this.isCartFullOfTryOn && this.getActiveRentPeriod === 3)
    },
    isSimple () {
      return this.getCurrentProduct.type_id === 'simple'
    },
    listByCode () {
      return this.$store.state.attribute.list_by_code
    },
    storeView () {
      return currentStoreView()
    },
    getMainCategory () {
      return this.getMenuCategories.find(cat => cat.id === config.server.categoryIdsMap.mainCategoryId)
    },
    designerCheck () {
      if (this.getCurrentProduct.type_id === 'simple') return this.getLabelFor('marketplace_designer') ? this.getLabelFor('marketplace_designer') : ''
      return this.getLabelFor('designer') ? this.getLabelFor('designer') : ''
    }
  },
  methods: {
    getLabelFor (type) {
      if (this.listByCode && this.listByCode[type]) {
        if (Array.isArray(this.getCurrentProduct[type])) {
          let resultString = []
          this.getCurrentProduct[type].forEach(code => {
            resultString.push(this.listByCode[type].options.find(option => Number(option.value) === code).label)
          })
          return resultString.join(', ')
        }
        let items = this.listByCode[type].options && this.listByCode[type].options.filter((option) => {
          return String(option.value) === String(this.getCurrentProduct[type])
        })
        if (items && items.length) {
          return items[0].label
        } else {
          return false
        }
      }
    },
    getAllAttributeList (value) {
      return this.attributesByCode[value] ? this.attributesByCode[value].frontend_label : 'Product info Tab'
    }
  }
}
